var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherSunny(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 7.33329V0.666626H20.6667V7.33329H17.3333ZM28.4167 11.9166L26.125 9.62496L30.7917 4.83329L33.125 7.20829L28.4167 11.9166ZM30.6667 20.6666V17.3333H37.3333V20.6666H30.6667ZM17.3333 37.3333V30.6666H20.6667V37.3333H17.3333ZM9.58333 11.8333L4.83333 7.20829L7.20833 4.87496L11.9167 9.58329L9.58333 11.8333ZM30.75 33.1666L26.125 28.375L28.375 26.125L33.125 30.7083L30.75 33.1666ZM0.666666 20.6666V17.3333H7.33333V20.6666H0.666666ZM7.20833 33.1666L4.875 30.7916L9.54167 26.125L10.75 27.25L11.9583 28.4166L7.20833 33.1666ZM19 29C16.2222 29 13.8611 28.0277 11.9167 26.0833C9.97222 24.1388 9 21.7777 9 19C9 16.2222 9.97222 13.8611 11.9167 11.9166C13.8611 9.97218 16.2222 8.99996 19 8.99996C21.7778 8.99996 24.1389 9.97218 26.0833 11.9166C28.0278 13.8611 29 16.2222 29 19C29 21.7777 28.0278 24.1388 26.0833 26.0833C24.1389 28.0277 21.7778 29 19 29Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherSunny);
export default __webpack_public_path__ + "static/media/weather-sunny.176e3bb2d278ae495ed0c8f914113711.svg";
export { ForwardRef as ReactComponent };